import { Button, Dropdown, Groupper, Header, Icon, IconName, Input, Message, useFrontier, Field, Toolbar, Table, Label, Modal, Calendar } from "react-frontier-v2";
import { useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams,  } from "react-router-dom";
import API from "../API";
import { EventDate, Issue, IssuesStatus, IssueType, SetLoading, UserClass, UserTag } from "../SiteClasses";
import { BlockTypeSelect, BoldItalicUnderlineToggles, headingsPlugin, listsPlugin, ListsToggle, markdownShortcutPlugin, MDXEditor, MDXEditorMethods, quotePlugin, thematicBreakPlugin, toolbarPlugin, UndoRedo, tablePlugin, InsertTable } from "@mdxeditor/editor";
import { IssueComments, SearchEventModal, UserMentions } from "../components";
import '@mdxeditor/editor/style.css';
import { useBreadcrumbs, useUser } from "../hooks";
import UserAccess from "../UserAccess";
import { bindClick, bindFormChange, priorityColor, priorityText, statusColor, timeConverter, getScheduleInfo, sortedToPriority } from "../SiteUtil";
import { Dropdown as DropdownSemantic } from "semantic-ui-react";
import Validator from "../Validator";
import moment from "moment";

enum Modals{
   SEARCH_EVENT = 1,
   CHANGE_DATE = 2,
   REMOVE_EVENT = 3,
   REMOVE_USER = 4,
   REMOVE_TYPE = 5
}

var IssueEdit=()=>{
   var { user, hasAccess } = useUser();
   var navigate = useNavigate();
   var { Toast } = useFrontier();
   var { setTitle } = useBreadcrumbs();
   var { id } = useParams<{id: string}>();
   var [searchParams] = useSearchParams();
   var [errorPrompts, setErrorPrompts]=useState<string[]>(null);
   var [issue, setIssue]=useState<Issue>(null);
   var [tags, setTags]=useState<UserTag[]>(null);
   var [issueTypes, setIssueTypes]=useState<IssueType[]>(null);
   var [loadError, setLoadError]=useState<string>(null);
   var [errors, setErrors]=useState<string[]>([]);
   var isCreate = id === 'create';
   var [isEditMode, setIsEditMode] = useState<boolean>(isCreate);
   var [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
   var [statusModalOpen, setStatusModalOpen] = useState<boolean>(false);
   var [newStatus, setNewStatus] = useState<number>(0);
   var [shownModal, setShownModal] = useState<Modals>(null);
   var [dateSchedule, setDateSchedule] = useState<Date>(null);
   var [event, setEvent] = useState<EventDate>(null);
   var [userToRemove, setUserToRemove] = useState<UserClass>(null);
   var [typeToRemove, setTypeToRemove] = useState<IssueType>(null);
   var editorRef = useRef<MDXEditorMethods>(null);
   var safeValue = '';

   var getTags=()=>{
      API.getAllTags().then((res)=>{
         if(res.error) return setLoadError(res.message);
         setTags(res.data);
      }).catch(()=>{
         setLoadError('Hubo un error inesperado cargando los departamentos.');
      })
   }

   var getIssueTypes=()=>{
      API.getAllIssueType().then((res)=>{
         if(res.error) return setLoadError(res.message);
         setIssueTypes(res.data);
      }).catch(()=>{
         setLoadError('Hubo un error inesperado cargando los tipos de tareas.');
      })
   }

   var addTaggedUser=(userSelect: UserClass)=>{
      setErrors(null);
      if(userSelect.user_id === user.user_id) return setErrors(["El dueño de la tarea no se puede auto etiquetar."]);
      setIssue(prev=>{
         if(prev.users.find(u=>u.user_id === userSelect.user_id)) return prev;
         return {...prev, users: [...prev.users, userSelect]};
      });
   }

   var removeTaggedUser=(user: UserClass)=>{
      if(issue.issue_id){
         setUserToRemove(user);
         setShownModal(Modals.REMOVE_USER);
      } else {
         setIssue(prev=>({...prev, users: prev.users.filter(u=>u.user_id !== user.user_id)}));
      }
   }

   var onConfirmRemoveUser=(setLoading: SetLoading)=>{
      setLoading(true);
      setErrors(null);
      API.removeIssueUser(issue.issue_id, userToRemove.user_id).then((res)=>{
         if(res.error) return setErrors([res.message]);
         Toast.success('Usuario eliminado exitosamente.');
         setIssue(prev=>({...prev, users: prev.users.filter(u=>u.user_id !== userToRemove.user_id)}));
         setShownModal(null);
      }).catch(()=>{
         setErrors(['Hubo un error inesperado eliminando el usuario.']);
      }).finally(()=>setLoading(false));
   }

   var onCreate=(setLoading: SetLoading)=>{
      var { valid, prompts } = Validator({
         title: issue.title.trim(),
         content: issue.content.trim(),
         // type_id: issue.issue_type.type_id, <- Pendiente
         status_id: issue.status.status_id,
         priority: issue.priority,
         tag_id: issue.tag.tag_id,
      }, {
         title: [{ rule: 'empty', label: 'Título', prompt: 'Favor de ingresar el título' }],
         content: [{ rule: 'empty', label: 'Descripción', prompt: 'Favor de ingresar la descripción' }],
         // type_id: [{ rule: 'min', params: [1], label: 'Tipo', prompt: 'Favor de seleccionar el tipo de tarea' }],
         status_id: [{ rule: 'min', params: [1], label: 'Estatus', prompt: 'Favor de seleccionar el estatus' }],
         priority: [{ rule: 'min', params: [1], label: 'Prioridad', prompt: 'Favor de seleccionar la prioridad' }],
         tag_id: [{ rule: 'min', params: [1], label: 'Departamento', prompt: 'Favor de seleccionar un departamento' }],
      });

      setErrors(prompts);
      if(!valid) return;

      setLoading(true);
      if(isCreate){
         API.createIssue(issue).then((res)=>{
            if(res.error) return setErrors([res.message]);
            Toast.success('Tarea creada exitosamente.');
            setIssue(prev=>({...prev, issue_id: res.data}));
            navigate(`/issues/${res.data}`, {replace: true});
         }).catch(()=>{
            setErrors(['Hubo un error inesperado creando la tarea.']);
         }).finally(()=>{setLoading(false)});
      }else{
         API.updateIssue(issue).then((res)=>{
            if(res.error) return setErrors([res.message]);
            setIssue(prev=>{
               return {
                  ...prev,
                  users: prev.users.filter(u=>u.user_id!==issue.user_creator.user_id)
               }
            })
            Toast.success('Tarea actualizada exitosamente.');
            setIsEditMode(false);
         }).catch(()=>{
            setErrors(['Hubo un error inesperado actualizando la tarea.']);
         }).finally(()=>{setLoading(false)});
      }
   };

   useEffect(()=>{
      Promise.all([
         getTags(),
         getIssueTypes()
      ]).catch((error)=>setLoadError(error));
   },[])

   useEffect(()=>{
      if (editorRef.current) {
        var currentMarkdown = editorRef.current.getMarkdown();
        if (currentMarkdown !== safeValue) {
          editorRef.current.setMarkdown(safeValue);
        }
      }
   }, [safeValue]);

   useEffect(()=>{
      if(isCreate) {
         setIsEditMode(true);
         setTitle('Agregar tarea');
         setIssue({
            issue_id: null,
            title: '',
            content: '',
            issue_types: [],
            status: {
               status_id: parseInt(searchParams.get('status_id')) || 0,
               status_name: '',
            },
            priority: 0,
            tag: {
               tag_id: user.tags?.[0]?.tag_id || 0,
               tag_name: user.tags?.[0]?.tag_name || '',
            },
            users: [],
            date_schedule: null,
            user_creator: null
         });
      }else{
         setIsEditMode(false);
         setTitle(`Editar tarea #${id}`);
         API.getIssue(parseInt(id)).then((res)=>{
            if(res.error) return setLoadError(res.message);
            setIssue(res.data);
         }).catch(()=>{
            setLoadError('Hubo un error inesperado al cargar el tarea.');
         });
      }
   },[id, isCreate]);

   var editorId = useMemo(() => 'mdx_' + Math.random().toString(36).substr(2, 9), []);
   var onFormChange = bindFormChange(issue, setIssue);

   var onDelete = () => {
      setErrorPrompts(null);
      setDeleteModalOpen(true);
   };

   var onConfirmDelete = (setLoading: SetLoading) => {
      setLoading(true);
      setErrorPrompts(null);
      API.deleteIssue(issue.issue_id).then((res) => {
         if(res.error) return setErrorPrompts([res.message]);
         Toast.success('Tarea eliminada exitosamente.');
         setDeleteModalOpen(false);
         navigate('/issues', { replace: true });
      }).catch(() => {
         setErrorPrompts(['Hubo un error inesperado al eliminar la tarea.']);
      }).finally(() => {
         setLoading(false);
      });
   };

   var onChangeStatus = (setLoading: SetLoading) => {
      if(!newStatus) return setErrorPrompts(['Favor de seleccionar un estatus']);
      setLoading(true);
      setErrorPrompts(null);
      API.updateIssueStatus(issue.issue_id, newStatus).then((res) => {
         if(res.error) return setErrorPrompts([res.message]);
         Toast.success('Estatus actualizado exitosamente.');
         setStatusModalOpen(false);
         API.getIssue(issue.issue_id).then(r => setIssue(r.data));
      }).catch(() => {
         setErrorPrompts(['Hubo un error inesperado al actualizar el estatus.']);
      }).finally(() => {
         setLoading(false);
      });
   };

   var onEventSelected=(event: any)=>{
      var exist=issue.events?.some(e=>e.date_id===event.date_id);
      if(exist)return Toast.error('El evento ya está agregado');
      setIssue(prev=>({
         ...prev,
         events: [...prev.events || [], { ...event, date_id: event.date_id, event_name: event.event_name, date: event.date}]
      }))
      onCloseModal();
   }

   var onEventRemove=(setLoading: SetLoading)=>{
      setLoading(true);
      API.removeIssueEvent(issue.issue_id, event.date_id).then((res)=>{
         if(res.error) return Toast.error(res.message);
         setIssue(prev=>({...prev, events: prev.events?.filter(e=>e.date_id!==event.date_id)}));
         Toast.success('Evento eliminado exitosamente.');
         setShownModal(null);
      }).catch(()=>{
         Toast.error('Hubo un error inesperado al eliminar el evento.');
      }).finally(()=>{
         setLoading(false);
      })
   }

   var setTypes=(ids: number[])=>{
      if (ids.length < issue.issue_types.length && issue.issue_id) {
         var removedId = issue.issue_types.find(it => !ids.includes(it.type_id))?.type_id;
         if (removedId) {
            var removedType = issue.issue_types.find(it => it.type_id === removedId);
            setTypeToRemove(removedType);
            setShownModal(Modals.REMOVE_TYPE);
         }
      } else {
         setIssue(prev=>({
            ...prev,
            issue_types: ids.map((id)=>{
               var foundType = issueTypes.find((it)=>it.type_id===id);
               return { 
                  type_id: id,
                  type_name: foundType.type_name,
                  type_icon: foundType.type_icon
               };
            })
         }));
      }
   }

   var onConfirmRemoveType=(setLoading: SetLoading)=>{
      setLoading(true);
      setErrors(null);
      API.removeIssueType(issue.issue_id, typeToRemove.type_id).then((res)=>{
         if(res.error) return setErrors([res.message]);
         Toast.success('Tipo eliminado exitosamente.');
         setIssue(prev=>({...prev, issue_types: prev.issue_types.filter(it=>it.type_id !== typeToRemove.type_id)}));
         setShownModal(null);
      }).catch(()=>{
         setErrors(['Hubo un error inesperado eliminando el tipo.']);
      }).finally(()=>setLoading(false));
   }

   var onConfirmRemoveEvent=(event: EventDate)=>{
      setShownModal(Modals.REMOVE_EVENT);
      setEvent(event);
   }

   var onCloseModal=()=>{  
      setShownModal(null);
   }

   var convertUnix=(value: Date)=>{
      return moment(value).unix();
   }

   if(loadError) return <Header text={'Error'} subtext={loadError} />
   
   return <div>
         <Groupper 
            style={{ width: '100%', margin: '20px auto', maxWidth: 650 }} 
            title={isCreate ? 'Agregar tarea' : `Tarea #${issue?.issue_id || id}`}
            actions={isEditMode ? <>
               <Button text="Cancelar" basic style={{ marginRight: 10 }} onClick={() => { setErrors([]); isCreate ? navigate('/issues') : setIsEditMode(false); }} />
               {((isCreate && hasAccess(UserAccess.ISSUES.CREATE_ISSUES)) || (!isCreate && hasAccess(UserAccess.ISSUES.EDIT_ISSUES))) && (
                  <Button text={isCreate ? "Crear" : "Guardar"} color="black" onClick={onCreate} />
               )}
            </> : null}
            fitted={!isEditMode}
         >
         {!tags || !issueTypes || !issue
            ? <Header loading />
            : isEditMode ? <div style={{ padding: 15 }}> 
            <Input label="Titulo" value={issue?.title} onChange={onFormChange('title')} style={{ marginBottom: 15 }} />
            <Field amount={2} style={{ gap: 15, marginBottom: 15 }}>
               <Dropdown 
                  style={{ width: '100%' }}
                  label="Departamento"
                  value={issue.tag.tag_id}
                  onValueChange={(e)=>onFormChange('tag')({tag_id: e,tag_name: tags.find((tag)=>tag.tag_id === e)?.tag_name})}
                  items={[
                     ...(tags || []).map((tag)=>{
                        return {
                           text: tag.tag_name,
                           value: tag.tag_id
                        }
                     })
                  ]}
               />
               <Dropdown 
                  style={{ width: '100%' }}
                  label="Prioridad"
                  value={issue.priority}
                  onValueChange={onFormChange('priority')}
                  items={[
                     {value: 1, text: 'Baja'},
                     {value: 2, text: 'Media'},
                     {value: 3, text: 'Alta'},
                     {value: 4, text: 'Crítica'}
                  ]}
               />
            </Field>
            <Dropdown 
               label="Estatus"
               value={issue.status.status_id}
               onValueChange={(e)=>onFormChange('status')({status_id: e, status_name: ''})}
               items={[
                  {value: IssuesStatus.PENDING, text: 'Abierto'},
                  {value: IssuesStatus.IN_PROGRESS, text: 'En progreso'},
                  {value: IssuesStatus.ON_HOLD, text: 'En espera'},
                  {value: IssuesStatus.RESOLVED, text: 'Resuelto'},
                  {value: IssuesStatus.CANCELLED, text: 'Cancelado'}
               ]}
            />
            <Field label="Tipos">
               <DropdownSemantic 
                  multiple
                  selection
                  placeholder='Tipos' 
                  value={issue.issue_types.map(type=>type.type_id)}
                  options={(issueTypes||[]).map((it)=>({
                     value: it.type_id, 
                     text: <><Icon name={it.type_icon as IconName} /> {it.type_name}</> 
                  }))} 
                  onChange={(e, { value, text })=>setTypes(value as number[])}
               />
            </Field>
            <Field label="Usuarios" >
               <UserMentions taggedUsers={issue.users} setTaggedUsers={addTaggedUser} removeTaggedUser={removeTaggedUser} />
            </Field>
            <Button 
               style={{ marginBottom: 15 }}
               iconName="calendar-plus"
               text={issue.date_schedule ? `Fecha: ${timeConverter(issue.date_schedule)}` : "Agregar fecha"}
               color="black"
               menu={[
                  {
                     text: "Fecha custom",
                     iconName: "calendar",
                     onClick: ()=>setShownModal(Modals.CHANGE_DATE)
                  },
                  ...(issue.events || []).map((event) => ({
                     text: `${event.event_name.slice(0,10)}... (${timeConverter(event.date)})`,
                     iconName: "calendar" as IconName,
                     onClick: ()=>onFormChange('date_schedule')(event.date)
                  }))
               ]}
            />
            <Field label="Descripción" style={{ width: '100%' }}>
               <style>{`
                  #${editorId} {
                     width: 100% !important;
                     flex: 1 1 100% !important;
                  }
                  #${editorId} .mdxeditor {
                     width: 100% !important;
                  }
                  #${editorId} .mdxeditor-toolbar {
                     width: 100% !important;
                     box-sizing: border-box !important;
                  }
                  #${editorId} .modern-editor-content {
                     width: 100% !important;
                     outline: none;
                     box-sizing: border-box !important;
                  }
                  #${editorId} .modern-editor-content p {
                     margin: 0 0 1em;
                  }
                  #${editorId} .modern-editor-content h1,
                  #${editorId} .modern-editor-content h2,
                  #${editorId} .modern-editor-content h3,
                  #${editorId} .modern-editor-content h4,
                  #${editorId} .modern-editor-content h5,
                  #${editorId} .modern-editor-content h6 {
                     margin: 1.2em 0 0.5em;
                     font-weight: 700;
                  }
                  #${editorId} .modern-editor-content ul,
                  #${editorId} .modern-editor-content ol {
                     margin: 0 0 1em 1.5em;
                     padding: 0;
                  }
               `}</style>
               <div id={editorId} style={{ width: '100%', flex: 1, border: '1px solid rgba(34, 36, 38, 0.15)', borderRadius: '10px', minHeight: 180, maxHeight: 400, overflowY: 'auto', background: '#fff', boxSizing: 'border-box' }}>
                  <MDXEditor
                     markdown={issue.content}
                     onChange={onFormChange('content')}
                     plugins={[  
                        headingsPlugin(),
                        listsPlugin(), 
                        quotePlugin(),
                        thematicBreakPlugin(),
                        tablePlugin(),
                        markdownShortcutPlugin(),
                        toolbarPlugin({
                           toolbarContents: () => (
                              <>
                                 <UndoRedo />
                                 <BoldItalicUnderlineToggles />
                                 <BlockTypeSelect />
                                 <ListsToggle />
                                 <InsertTable />
                              </>
                           )
                        })
                     ]}
                     ref={editorRef}
                     contentEditableClassName="modern-editor-content"
                  />
               </div>
            </Field>
            <Table>
               <Table.Head 
                  title="EVENTOS"
                  titleRight={
                     <Button text="Agregar evento" color="black" iconName="plus-circle" onClick={bindClick(setShownModal, Modals.SEARCH_EVENT)} />
                  }
               >
                  <Table.Row>
                     <Table.Cell header>Evento</Table.Cell>
                     <Table.Cell header>Nombre</Table.Cell>
                     <Table.Cell header>Fecha</Table.Cell>
                     <Table.Cell header collapsing centered><Icon name="wrench" /></Table.Cell>
                  </Table.Row>
               </Table.Head>
               <Table.Body>
                  {issue.events && issue.events.length>0
                     ?issue.events.map((event,idx)=>(
                        <Table.Row key={idx}>
                           <Table.Cell>{event.date_id}</Table.Cell>
                           <Table.Cell>{event.event_name}</Table.Cell>
                           <Table.Cell>{timeConverter(event.date)}</Table.Cell>
                           <Table.Cell collapsing>
                              <Button 
                                 icon
                                 size="tiny" 
                                 iconName="ellipsis-h" 
                                 menu={[
                                    {
                                       text: 'Eliminar',
                                       iconName: 'trash',
                                       onClick: () => onConfirmRemoveEvent(event)
                                    }
                                 ]} 
                              />
                           </Table.Cell>
                        </Table.Row>
                     ))
                     :  <Table.Row>
                           <Table.Cell colSpan={3} style={{ textAlign: 'center', padding: 20, color: 'gray' }}>
                              No hay eventos
                           </Table.Cell>
                        </Table.Row>
                  }
               </Table.Body>
            </Table>
            {errors && errors.length>0&&(
               <Message type="error" list={errors} style={{ marginTop: 15 }} />
            )}
            </div> : <>
					<Toolbar stretch>
						{hasAccess(UserAccess.ISSUES.EDIT_ISSUES) && (
							<Toolbar.Item text='Editar' iconName='pencil' onClick={() => { setErrors([]); setIsEditMode(true); }}/>
						)}
						{hasAccess(UserAccess.ISSUES.EDIT_ISSUES) && (
							<Toolbar.Item text='Cambiar estatus' iconName='exchange-alt' onClick={() => { setNewStatus(issue.status.status_id); setErrorPrompts(null); setStatusModalOpen(true); }}/>
						)}
						{hasAccess(UserAccess.ISSUES.DELETE_ISSUES) && (
							<Toolbar.Item text='Eliminar' iconName='trash' onClick={onDelete}/>
						)}
					</Toolbar>
               <Table details striped fitted>
                  <Table.Body>
                     <Table.Row data={['Título', issue.title]} />
                     <Table.Row data={['Departamento', issue.tag.tag_name]} />
                     <Table.Row data={['Prioridad', <Label color={priorityColor(issue.priority)} value={priorityText(issue.priority)} />]} />
                     <Table.Row data={['Estatus', <Label value={issue.status.status_name || 'Desconocido'} color={statusColor(issue.status.status_id)} />]} />
                     <Table.Row 
                        data={[
                           issue.issue_types.length===1? 'Tipo' : 'Tipos', 
                           <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>{
                              sortedToPriority(issue.issue_types).map(type=>(
                                 <Label
                                    key={type.type_id}
                                    style={{ display: 'flex' }}
                                    size="small"
                                    iconName={type.type_icon as IconName}
                                    value={type.type_name}
                                 />
                              ))
                           }
                           </div>
                        ]} 
                     />
                     <Table.Row 
                        data={[
                           'Fecha promesa', 
                           issue.date_schedule ? (
                              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                 <span>{timeConverter(issue.date_schedule)}</span>
                                 {(() => {
                                    var schedule = getScheduleInfo(issue.date_schedule, issue.status?.status_id);
                                    return schedule ? (
                                       <Label 
                                          size="small" 
                                          color={schedule.isUrgent ? 'red' : undefined} 
                                          iconName="calendar-alt" 
                                          value={schedule.text} 
                                       />
                                    ) : null;
                                 })()}
                              </div>
                           ) : <Icon name="minus" />
                        ]} 
                     />
                     <Table.Row data={['Creador', issue.user_creator ? issue.user_creator.first_name + ' ' + issue.user_creator.last_name : 'Desconocido']} />
                  </Table.Body>
               </Table>
               <Groupper fitted title='Descripción' style={{ borderRadius: 0, boxShadow: 'none' }}>
                  <div style={{ padding: 15, maxHeight: 400, overflowY: 'auto' }}>
                     <style>{`
                        #${editorId} {
                           width: 100% !important;
                        }
                        #${editorId} .mdxeditor {
                           width: 100% !important;
                        }
                        #${editorId} .modern-editor-content {
                           width: 100% !important;
                           outline: none;
                           box-sizing: border-box !important;
                        }
                        #${editorId} .modern-editor-content p {
                           margin: 0 0 1em;
                        }
                        #${editorId} .modern-editor-content h1,
                        #${editorId} .modern-editor-content h2,
                        #${editorId} .modern-editor-content h3,
                        #${editorId} .modern-editor-content h4,
                        #${editorId} .modern-editor-content h5,
                        #${editorId} .modern-editor-content h6 {
                           margin: 1.2em 0 0.5em;
                           font-weight: 700;
                        }
                        #${editorId} .modern-editor-content ul,
                        #${editorId} .modern-editor-content ol {
                           margin: 0 0 1em 1.5em;
                           padding: 0;
                        }
                     `}</style>
                     <div id={editorId} style={{ width: '100%' }}>
                        <MDXEditor
                           markdown={issue.content}
                           readOnly={true}
                           plugins={[  
                              headingsPlugin(),
                              listsPlugin(), 
                              quotePlugin(),
                              thematicBreakPlugin(),
                              tablePlugin()
                           ]}
                           contentEditableClassName="modern-editor-content"
                        />
                     </div>
                  </div>
               </Groupper>

               {issue.events?.length>0&&(
                  <Table striped fitted>
                     <Table.Head title="EVENTOS">
                        <Table.Row>
                           <Table.Cell header>Evento</Table.Cell>
                           <Table.Cell header>Nombre</Table.Cell>
                           <Table.Cell header>Fecha</Table.Cell>
                           <Table.Cell header></Table.Cell>
                        </Table.Row>
                     </Table.Head>
                     <Table.Body>
                        {issue.events.map(e=>(
                           <Table.Row key={e.date_id}>
                              <Table.Cell collapsing>{e.date_id}</Table.Cell>
                              <Table.Cell>{e.event_name}</Table.Cell>
                              <Table.Cell collapsing>{timeConverter(e.date)}</Table.Cell>
										<Table.Cell collapsing compact><Link style={{  }} to={`/events/${e.date_id}`} target="_blank"><Icon name="eye"/></Link></Table.Cell>
                           </Table.Row>
                        ))}
                     </Table.Body>
                  </Table>
               )}
               {issue.users?.length > 0 && (
                  <Table striped fitted>
                     <Table.Head title="USUARIOS ETIQUETADOS">
                        <Table.Row>
                           <Table.Cell header>Nombre</Table.Cell>
                           <Table.Cell header collapsing>Correo</Table.Cell>
                        </Table.Row>
                     </Table.Head>
                     <Table.Body>
                        {issue.users.map(u => (
                           <Table.Row 
                              key={u.user_id} 
                              data={[
                                 u.first_name + ' ' + u.last_name,
                                 u.email
                              ]} 
                           />
                        ))}
                     </Table.Body>
                  </Table>
               )}
            </>
         }
         </Groupper>

         {!isEditMode && issue && (
				<Groupper title="Comentarios" style={{ width: '100%', margin: '20px auto', maxWidth: 800 }}>
					<div style={{ padding: 15 }}>
						<IssueComments issueId={issue?.issue_id} />
					</div>
				</Groupper>
         )}

      <Modal open={deleteModalOpen} onClose={() => setDeleteModalOpen(false)} size="tiny">
         <Modal.Header text="¿Eliminar tarea?" />
         <Modal.Content>
            <Header text={`¿Estás seguro de que deseas eliminar la tarea #${issue?.issue_id}?`} subtext="Esta acción no se puede deshacer." />
            {errorPrompts && <Message type="error" list={errorPrompts} style={{ marginTop: 15 }} />}
         </Modal.Content>
         <Modal.Actions>
            <Button text="Cancelar" basic onClick={() => setDeleteModalOpen(false)} />
            <Button text="Eliminar" color="red" onClick={onConfirmDelete} />
         </Modal.Actions>
      </Modal>
      <Modal open={shownModal === Modals.REMOVE_EVENT} onClose={() => setShownModal(null)} size="tiny">
         <Modal.Header text="Eliminar evento" />
         <Modal.Content>
            <Header text={`¿Estás seguro de que deseas eliminar el evento '${event?.event_name}'?`} subtext="Esta acción no se puede deshacer." />
            {errorPrompts && <Message type="error" list={errorPrompts} style={{ marginTop: 15 }} />}
         </Modal.Content>
         <Modal.Actions>
            <Button text="Cancelar" basic onClick={() => setShownModal(null)} />
            <Button text="Eliminar" color="red" onClick={onEventRemove} />
         </Modal.Actions>
      </Modal>
      <Modal open={shownModal === Modals.REMOVE_USER} onClose={() => setShownModal(null)} size="tiny">
         <Modal.Header text="Eliminar usuario" />
         <Modal.Content>
            <Header text={`¿Estás seguro de que deseas eliminar a ${userToRemove?.first_name} ${userToRemove?.last_name}?`} subtext="El usuario será removido de esta tarea." />
            {errors?.length > 0 && <Message type="error" list={errors} style={{ marginTop: 15 }} />}
         </Modal.Content>
         <Modal.Actions>
            <Button text="Cancelar" basic onClick={() => setShownModal(null)} />
            <Button text="Eliminar" color="red" onClick={onConfirmRemoveUser} />
         </Modal.Actions>
      </Modal>
      <Modal open={shownModal === Modals.REMOVE_TYPE} onClose={() => setShownModal(null)} size="tiny">
         <Modal.Header text="Eliminar tipo" />
         <Modal.Content>
            <Header text={`¿Estás seguro de que deseas remover el tipo '${typeToRemove?.type_name}'?`} subtext="El tipo será desvinculado de esta tarea de forma inmediata." />
            {errors?.length > 0 && <Message type="error" list={errors} style={{ marginTop: 15 }} />}
         </Modal.Content>
         <Modal.Actions>
            <Button text="Cancelar" basic onClick={() => {setShownModal(null)}} />
            <Button text="Eliminar" color="red" onClick={onConfirmRemoveType} />
         </Modal.Actions>
      </Modal>
      <Modal open={statusModalOpen} onClose={() => setStatusModalOpen(false)} size="mini">
         <Modal.Header text="Modificar estatus" />
         <Modal.Content>
            <Dropdown 
               value={newStatus}
               label="Nuevo estatus"
               onValueChange={setNewStatus}
               style={{ width: '100%', marginBottom: 15 }}
               items={[
                  {value: IssuesStatus.PENDING, text: 'Abierto'},
                  {value: IssuesStatus.IN_PROGRESS, text: 'En progreso'},
                  {value: IssuesStatus.ON_HOLD, text: 'En espera'},
                  {value: IssuesStatus.RESOLVED, text: 'Resuelto'},
                  {value: IssuesStatus.CANCELLED, text: 'Cancelado'},
                  ...(issue && issue.status.status_id === IssuesStatus.RESOLVED ? [{value: IssuesStatus.CONFIRMED, text: 'Confirmado'}] : [])
               ]}
            />
            {errorPrompts && <Message type="error" list={errorPrompts} style={{ marginTop: 15 }} />}
         </Modal.Content>
         <Modal.Actions>
            <Button text="Cancelar" basic onClick={() => setStatusModalOpen(false)} />
            <Button text="Guardar" color="black" onClick={onChangeStatus} />
         </Modal.Actions>
      </Modal>
      <Modal open={shownModal === Modals.CHANGE_DATE} onClose={() => setShownModal(null)} size="tiny">
         <Modal.Header text="Modificar fecha" />
         <Modal.Content>
            <Calendar 
               mode={'date'} 
               date={dateSchedule}
               onSelected={(e)=>setDateSchedule(e)} 
               minDate={moment().toDate()}
            />
         </Modal.Content>
         <Modal.Actions>
            <Button text="Cancelar" basic onClick={() => setShownModal(null)} />
            <Button 
               text="Guardar" 
               color="black" 
               onClick={()=>{
                  onFormChange('date_schedule')(convertUnix(dateSchedule))
                  setShownModal(null);
               }} 
            />
         </Modal.Actions>
      </Modal>
      <SearchEventModal
			open={shownModal === Modals.SEARCH_EVENT}
			onClose={onCloseModal}
			onSelected={onEventSelected}
		/>
   </div> 
}

export default IssueEdit;